export const useGetWindowSize = () => ({
  width: window.innerWidth,
  height: window.innerHeight,
});
